import { createAction } from '@reduxjs/toolkit'

const updateConnectedAccount = createAction('router/updateConnectedAccount')

export const routerActions = {
  updateConnectedAccount,
}
